import {Component, Input, OnInit} from '@angular/core';
import {environment} from '../../../../../environments/environment';

@Component({
    selector: 'app-social-sharing-dialog',
    templateUrl: './social-sharing-dialog.component.html',
    styleUrls: ['./social-sharing-dialog.component.scss']
})
export class SocialSharingDialogComponent implements OnInit {

    @Input() share = '';

    constructor() {
    }

    ngOnInit(): void {
        this.share = environment.frontUrl + '/lightbox/share/' + this.share;
     //  console.log(this.share);
    }


    onDismiss(): void {
        this.closeModal();
    }

    closeModal() {
        let modal = document.querySelector('.login-modal') as HTMLElement;
        if (modal) {
            modal.click();
        }
    }
}
